<template>
  <div class="full-height" id="generate-latis-start">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-xs">
            <div class="crud-title">
            </div>
          </q-card-section>
          <q-card-section class="q-px-md">
            <jt-dynamic-form
              ref="dynamicForm"
              :inputs="elements[0].inputs"
              :relacionamentos="elements[0].relacionamentos"
              :model="elements[0].dadosForm"
              :interface="elements[0].nmInterface"
              form-class="form dynamic generateLatisForms"
              @composition-button-click="actionButtonComposition"
              @composition-modal-close="compositionModalCloseHandler"
              @search-found="
                (event) => {
                  $emit('search-found', event);
                }
              "
              @on-select-change="
                (event) => {
                  $emit('on-select-change', event);
                }
              "
              @on-select-ajax="
                (event) => {
                  $emit('on-select-ajax', event);
                }
              "
            />
          </q-card-section>
        </q-card>
      </div>
    </div>

    <div
      v-if="forms[0] && forms[0].buttons.length"
      class="row full-width q-col-gutter-lg justify-center q-py-md"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        :class="`col-lg-2 col-md-3 button-${buttonLowerCase(button)}`"
      >
        <q-btn
          :class="`full-width button-btn-${buttonLowerCase(button)}`"
          :color="`${getCollorButton(button.name)}`"
          @click="actionButton(button)"
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>

    <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>AGREEMENTS</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-pb-lg card-table">
            <jt-data-table
              v-if="datatable"
              ref="jtDataTable"
              class="table-file-latis"
              :forms="forms"
              :buttons="datatable.buttons"
              :fields="datatable.columns"
              :data="agreements"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :apiMode="false"
              :rowsPerPageInitial="20"
              :row-buttons="(agreements.length > 0  ? false : true)"
              :is-paginated="true"
              :selection-force="false"
              :column-edit="columnEdit"
              :row-set="rowSet"
              :bottom-edit="bottomEdit"
              :noneSelect="true"
              @selection="selection"
              @action-button="actionButtonTable"
              @show-message="showMessage"
              @click-row="
                (row) => {
                  $emit('click-row', row)
                }
              "
            >
            <template #header="{ props }">
          <q-tr :props="props" class="table-header">
            <q-th v-for="col in props.cols.filter((d) => {
                   return d.type != 'HIDDEN'})" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
            <q-th>
              {{ $gettext('MORE') }}
            </q-th>
          </q-tr>
        </template>
            <template #body="{ props }">
          <q-tr class="text-left">
            <q-td
              v-for="col in props.cols.filter((d) => {
                   return d.render != 'HIDDEN'})"
              :key="col.name"
              :props="props"
              style="color: #333"
            >
              <span v-if="col.field == 'agreementInvoiceStatus'">
                <invoice-situation
                  :text="isLate(props.row['dueDate']) && col.value == $gettext('OPEN_SUPPORT_CALL') ? (getSituationByKey($gettext('OVERDUE')).text) : col.value"
                  :color="isLate(props.row['dueDate']) && col.value == $gettext('OPEN_SUPPORT_CALL') ? getSituationByKey($gettext('OVERDUE')).color : getSituationByKey(col.value).color"
                />
              </span>
              <span v-else-if="col.field == 'agreementOriginalValue' || col.field == 'agreementTotalValue'">
                {{  $toLocaleStringBr(col.value) }}
              </span>
              <span v-else>
                {{ col.value }}
              </span>

            </q-td>
            <q-td>
              <q-btn
                    flat
                    round
                    color="primary"
                    :icon="
                      expandedRows[props.row.agreementInvoice] ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                    "
                    @click="toggleRowExpand(props.row.agreementInvoice)"
                  />
                  </q-td>
          </q-tr>
          <q-tr v-show="expandedRows[props.row.agreementInvoice]" :props="props">
            <q-td colspan="100%">
              <div class="row hidden-row">
                <div
                  v-for="(col, index) in props.cols.filter((d) => {
                   return d.render === 'HIDDEN'})"
                  :key="index"
                  style="padding: 5px 8px"
                  class="col-4 hidden-row-item"
                >
                  <strong
                    ><label>{{ col.label }}:</label></strong
                  >
                  {{
                    props.row[col.field]
                  }}
                </div>
              </div>
            </q-td>
          </q-tr>
        </template>
            </jt-data-table>

          </q-card-section>
        </q-card>

  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDynamicForm, JtechDataTableUtils, JtDataTable } from 'jtech-webcomps'
import AgreementReportController from './AgreementReportController'
import { __downloadFile } from 'src/shared/global/UtilFile'
import { isLate } from 'src/shared/global/UtilDate'
import { onlineGenerationFormat, csvReportFormat } from 'src/shared/global/UtilReport'
import InvoiceSituation from '../../concession/service-request/view/financial/invoice/component/InvoiceSituation.vue'
import { situationMap } from './agreement-situation.config'
import { date } from 'quasar'

@Component({
  name: 'agreementReportPage',
  mixins: [JtDataTable],
  components: { JtDynamicForm, InvoiceSituation },
  props: {
    params: { type: Object, required: true },
    datatable: { type: Object, required: true },
    name: String,
    page: String,
    label: String,
    labelPage: String,
    forms: { type: Array, required: true },
    parent: Object
  }
})
class AgreementReportPage extends Vue {
  expandedRows = {}
  agreements = []
  controller = AgreementReportController.getInstance();
  fileSrc = null;
  isLate = isLate;

  get elements () {
    return this.forms
  }

  toggleRowExpand (rowId) {
    this.$set(this.expandedRows, rowId, !this.expandedRows[rowId])
  }

  get tableData () {
    return this.data || []
  }

  buttonLowerCase (button) {
    return button.name?.toLowerCase()
  }

  getParams () {
    return this.forms[0].dadosForm
  }

  getCollorButton (name) {
    return name == 'btExportar' ? 'blue' : 'info'
  }

  limparForm () {
    Array.isArray(this.$refs.dynamicForm)
      ? this.$refs.dynamicForm[0].resetForm()
      : this.$refs.dynamicForm.resetForm()
    this.$emit('form-reset', { form: this.$refs.dynamicForm, page: this })
    this.agreements = []
    this.$refs.jtDataTable.refresh()
  }

  isValidForm () {
    return Array.isArray(this.$refs.dynamicForm)
      ? this.$refs.dynamicForm[0].isValidForm()
      : this.$refs.dynamicForm.isValidForm()
  }

  getSituationByKey (key) {
    if (key) {
      for (const situation in this.situationMap) {
        if (
          Object.prototype.hasOwnProperty.call(this.situationMap, situation)
        ) {
          const situationKeys = this.situationMap[situation].keys || []
          if (situationKeys.includes(key.toString())) {
            return this.situationMap[situation]
          }
        }
      }
    }
    return { text: key, color: '#fff' }
  }

  get situationMap () {
    return situationMap
  }

  async btSearch (params) {
    const { registros } = await this.controller.searchAgreement(params)
    this.agreements = registros
    this.$refs.jtDataTable.refresh()
  }

  async actionButton (button) {
    if (!this.isButtonValidForm(button) || this.isValidForm()) {
      await this.btSearch(this.getParams())
    } else {
      this.$emit('show-message', 'warning', 'REQUIRED_FIELDS_NOT_FILLED', this)
    }
  }

  actionButtonComposition (button) {
    this.$emit('composition-button-click', button)
  }

  compositionModalCloseHandler (f) {
    this.$emit('composition-modal-close', f)
  }

  isButtonValidForm (button) {
    return button.name.indexOf('btCancelar') < 0
  }

  filterButtons (button, dados) {
    return JtechDataTableUtils.filterButtons(button, dados)
  }

  async exportCsv ({ nmArquivo }) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo,
        7
      )
      this.fileSrc = URL.createObjectURL(result)

      this.$nextTick(() => {
        __downloadFile(this.fileSrc, 'agreementReport.agreementReport', '.csv')
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async icDownload (params) {
    try {
      const resolveLogicResult = await this.controller.exportCsv(
        { ...params, relFormaGeracao: onlineGenerationFormat, relFormatoRelatorio: csvReportFormat }
      )

      await this.exportCsv(resolveLogicResult)
    } catch (error) {
      console.error(error)
    }
  }

  actionButtonTable (button, params) {
    this.icDownload(this.getParams())
  }
}
export default AgreementReportPage
</script>
<style lang="stylus">
@import '~quasar-variables';

.generateLatisForms {
  #scroll-area {
    height: calc(20vh - 1px) !important;
  }
}

.table-file-latis {
  .jt-datatable {
    height: 45vh !important;
  }
}

.hidden-row-item:nth-child(even) {
  background-color: #f5f5f5; /* ou o que quiser */
}

.hidden-row-item:nth-child(odd) {
  background-color: #ffffff;
}

</style>
